import { render, staticRenderFns } from "./admin_printPostCoMailingInfo.vue?vue&type=template&id=82aa6212&scoped=true"
import script from "./admin_printPostCoMailingInfo.vue?vue&type=script&lang=js"
export * from "./admin_printPostCoMailingInfo.vue?vue&type=script&lang=js"
import style0 from "./admin_printPostCoMailingInfo.vue?vue&type=style&index=0&id=82aa6212&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82aa6212",
  null
  
)

export default component.exports